import(/* webpackMode: "eager", webpackExports: ["Dashboard"] */ "/workspace/src/components/dashboard.tsx");
